export default "__VITE_ASSET__9961640a__"